import { diff_match_patch } from "diff-match-patch"

/**
 * Produce HTML that highlights additions (green) and deletions (red strikethrough)
 * between two plain-text strings. Preserves Unicode characters including emojis.
 * Designed for use with <pre> elements that have `white-space: pre-wrap`.
 */
export function diffTextHtml(previous: string, current: string): string {
  const dmp = new diff_match_patch()
  const diffs = dmp.diff_main(previous ?? "", current ?? "")
  dmp.diff_cleanupSemantic(diffs)

  let html = ""
  for (const [type, text] of diffs) {
    // Only escape HTML special characters, preserve emojis and Unicode
    const safeText = String(text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
    // Note: We don't convert \n to <br> because we're using <pre> with whitespace-pre-wrap

    if (type === 1) {
      html += `<ins class="diff-add">${safeText}</ins>`
    } else if (type === -1) {
      html += `<del class="diff-del">${safeText}</del>`
    } else {
      html += safeText
    }
  }

  return html
}
